import React, { memo } from "react";

const Container = ({ children, maxWidth }) => (
  <div className="container" style={{ maxWidth }}>
    {children}
  </div>
);

export default memo(Container);
